// Preconfigurator: size/quantity popups, price calculation and configurator hand-off
// Receives the Lenis instance from scroll.js so the popups can pause smooth scrolling.
export default function (lenis) {

    const $ = jQuery;

    // PopUp

    $('[data-action="open_size_popup"]').click(function (e) {
        e.preventDefault(); // optional, to prevent default link behavior

        // Show popup
        $('.block__preconfigurator-size-popup').addClass('is-active');
        $('.block__preconfigurator-popup-overlay').addClass('is-active');

        lenis.stop();

        // Choose offset based on screen width
        var offset = $(window).width() < 762 ? -200 : 400;

        // Scroll to the #preconfig section smoothly
        $('html, body').animate({
            scrollTop: $('#preconfig').offset().top - offset
        }, 500); // 500ms duration
    });

    $('[data-action="open_quantity_popup"]').click(function (e) {
        e.preventDefault(); // optional, to prevent default link behavior

        $(this).css({
            'box-shadow': '0 0 0 2px $brand-1',
            'border-radius': '12px',
        });


        // Show popup
        $('.block__preconfigurator-quantity-popup').addClass('is-active');
        $('.block__preconfigurator-popup-overlay').addClass('is-active');

        lenis.stop();

        // Scroll to the #preconfig section smoothly
        $('html, body').animate({
            scrollTop: $('#preconfig').offset().top - 400
        }, 500); // 500ms duration
    });

    $('.block__preconfigurator-popup-overlay').click(function (e) {

        lenis.start();

        $('.block__preconfigurator-quantity-popup').removeClass('is-active');
        $('.block__preconfigurator-size-popup').removeClass('is-active');
        $('.block__preconfigurator-popup-overlay').removeClass('is-active');

        $('[data-action="open_quantity_popup"]').css({
            'box-shadow': '0 0 0 0px $brand-1',
            'border-radius': 'unset',
        });

    });

    $('[data-action="setup_size"]').click(function (e) {

        lenis.start();

        let chosensize = $(this).data('value');
        $('#size').val(chosensize).trigger('change');

        $('.block__preconfigurator-size-popup').removeClass('is-active');
        $('.block__preconfigurator-popup-overlay').removeClass('is-active');

    });

    $('[data-action="setup_custom_size"]').click(function (e) {

        lenis.start();

        let chosenCustomWidth = $('#width_custom_size').val();
        let chosenCustomHeight = $('#height_custom_size').val();

        if (!chosenCustomWidth || !chosenCustomHeight) {
            return
        }

        let data = chosenCustomWidth + ' x ' + chosenCustomHeight + ' cm';

        $('#size').val(data).trigger('change');

        $('.block__preconfigurator-size-popup').removeClass('is-active');
        $('.block__preconfigurator-popup-overlay').removeClass('is-active');

    });

    $(document).on('click', '[data-action="toggle_info_box"]', function (e) {
        $(this).closest('.block__preconfigurator-material-item').toggleClass('is-flipped');
    });

    // Pricing needs StickerData (localized on preconfigurator pages)
    if (typeof StickerData === 'undefined') return;

    const selectedOptions = {
        selectedMaterialPercentage: 0,
        selectedFinishesPercentage: 0
    };

    const priceCents = StickerData.base_prices.data[0].pricePerM2;
    const basePricePerM2 = priceCents / 100;
    let selectedWidth = 0;
    let selectedHeight = 0;

    function updateAndRender() {
        const sizeString = $('#size').val();
        if (sizeString && sizeString.includes('x')) {
            const sizeParts = sizeString.replace('cm', '').trim().split('x').map(s => parseFloat(s.trim()));
            if (sizeParts.length === 2 && !isNaN(sizeParts[0]) && !isNaN(sizeParts[1])) {
                selectedWidth = sizeParts[0];
                selectedHeight = sizeParts[1];
            }
        }

        renderQuantities();
        $('input[name="custom_quantity"]').trigger('input');
    }

    function getDiscountForM2(totalM2) {
        let discount = 0;

        StickerData.discounts.data.forEach(discountRule => {
            const threshold = parseFloat(discountRule.m2Threshold);
            if (totalM2 >= threshold && discountRule.type === 'normal') {
                discount = discountRule.percentage;
            }
        });

        return discount;
    }

    function calculateTotalStickerM2(quantity) {
        const stickerM2 = ((selectedWidth * selectedHeight) / 10000) * quantity;
        const minimumCM2 =  3000;
        return Math.max(stickerM2, minimumCM2 / 10000);
    }

    function calculatePrice(quantity) {
        const totalM2 = calculateTotalStickerM2(quantity);

        let pricePerM2 = basePricePerM2;
        pricePerM2 += basePricePerM2 * (selectedOptions.selectedMaterialPercentage / 100);
        pricePerM2 += basePricePerM2 * (selectedOptions.selectedFinishesPercentage / 100);

        let subtotal = totalM2 * pricePerM2;
        const discountPercent = getDiscountForM2(totalM2) || 0;
        let discounted = subtotal - (subtotal * discountPercent / 100);

        return { subtotal, discounted, discountPercent };
    }

    function renderQuantities() {
        const container = $('.block__preconfigurator-quantity-items');
        container.empty();

        const quantities = StickerData.quantities.data;
        const baseQty = quantities.find(q => q.defaultSelected) || quantities[0];

        let firstEnabledRendered = false;

        quantities.forEach(opt => {
            const priceObj = calculatePrice(opt.quantity);

            const showDiscount = (priceObj.discountPercent || 0) > 0
                && priceObj.discounted < priceObj.subtotal;

            // Wat tonen we als hoofdbedrag?
            const mainPrice = showDiscount ? priceObj.discounted : priceObj.subtotal;

            // Eventueel disablen als main price onder minimum zou vallen (zou nu niet gebeuren)
            const isBelowMinimum = false;

            const shouldBeChecked = !isBelowMinimum && (
                opt.defaultSelected || (!firstEnabledRendered && (firstEnabledRendered = true))
            );

            const html = `
              <label class="block__preconfigurator-quantity-item u-inner-align-center u-inner-row u-gap-sb ${isBelowMinimum ? 'is-disabled' : ''}">
                <span class="u-inner-row u-gap-16">
                  <span class="block__preconfigurator-quantity-item-quantity">${opt.quantity} St.</span>
                  <span class="u-inner-row u-gap-8">
                    <strong>€${mainPrice.toFixed(2).replace('.', ',')}</strong>
                    ${showDiscount ? `<s>€${priceObj.subtotal.toFixed(2).replace('.', ',')}</s>` : ''}
                  </span>
                </span>
                ${showDiscount ? `<span class="block__preconfigurator-quantity-item-korting">-${priceObj.discountPercent}%</span>` : ''}
                <input type="radio" name="quantity[]" value="${opt.quantity}" ${shouldBeChecked ? 'checked' : ''} ${isBelowMinimum ? 'disabled' : ''}>
              </label>
            `;

            container.append(html);
        });
    }


    // === Type Dropdown Population ===
    const $typeSelect = $('select[name="type"]');

    $.each(StickerData.types.data, function (i, type) {
        const selected = type.defaultSelected ? 'selected' : '';
        $typeSelect.append(`<option value="${type.uuid}" ${selected}>${type.label.trim()}</option>`);
    });

    // Override default selection based on the current URL slug
    const urlPath = window.location.pathname;
    const typeMatch = urlPath.match(/\/([^/]+)/);
    if (typeMatch) {
        let keyword = typeMatch[1]
            .toLowerCase()
            .replace(/-bestellen$/, '')
            .replace(/-/g, '')
            .trim();

        const matchedType = StickerData.types.data.find(type => {
            const normalizedLabel = type.label
                .toLowerCase()
                .replace(/-/g, '')
                .replace(/\s+/g, '');
            return normalizedLabel.includes(keyword);
        });

        if (matchedType) {
            $typeSelect.val(matchedType.uuid);
        }
    }

    $typeSelect.on('change', function () {
        const selectedTypeId = $(this).val();
        const selectedType = StickerData.types.data.find(t => t.uuid === selectedTypeId);
        const allowedMaterials = selectedType ? selectedType.allowedMaterials : [];

        updateAndRender(); // Recalculate size-based pricing

        const $materialContainer = $('.block__preconfigurator-material');
        $materialContainer.empty();

        $.each(StickerData.materials.data, function (i, material) {
            if (!allowedMaterials.includes(material.uuid)) return;

            const image = material.imageUrl ? `<img src="${material.imageUrl}" alt="Thumbnail material" />` : '';
            const title = material.label;
            const desc = material.description;

            const $item = $(`
            <label class="block__preconfigurator-material-item u-inner-column u-gap-8">
                <span class="u-inner-row u-inner-align-center u-gap-sb">
                    <span class="u-inner-row u-inner-align-center u-gap-8">
                        ${image}
                        <svg data-action="toggle_info_box" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                    </span>
                    <span class="block__preconfigurator-material-item-checkbox">
                        <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11 1L4.125 8L1 4.81818" stroke="$brand-1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                </span>
                <span class="block__preconfigurator-material-item-description u-inner-column u-gap-4">
                    <span class="u-inner-row u-inner-align-center u-gap-sb">
                        <strong>Informatie</strong>
                        <svg data-action="toggle_info_box" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                    </span>
                    <span>${desc}</span>
                </span>
                <span><strong>${title}</strong></span>
                <input type="radio" name="material" data-minheight="${material.minHeight}" data-maxheight="${material.maxHeight}" data-minwidth="${material.minWidth}" data-maxheight="${material.maxWidth}" value="${material.uuid}" />
            </label>
        `);

            $materialContainer.append($item);
        });

        $('select[name="afwerking"]').html('<option>Geen</option>');
        const $firstMaterial = $materialContainer.find('input[name="material"]').first();
        if ($firstMaterial.length) {
            $firstMaterial.prop('checked', true).trigger('change');
        }

    });

    // Trigger initial type selection
    setTimeout(() => {
        $typeSelect.trigger('change');
    }, 0);

    $(document).on('input', 'input[name="custom_quantity"]', function () {

        let value = calculatePrice($(this).val());

        let subtotal = parseFloat(value.subtotal).toFixed(2);

        let discounted = null;

        if (value.discounted) {
            discounted = parseFloat(value.discounted).toFixed(2);
        }

        if (subtotal == discounted) {
            discounted = null;
        }

        let discountPercent = value.discountPercent; // assuming this comes from calculatePrice

        // Clear container
        $('.block__preconfigurator-quantity-custom-price').empty();


        let html = `
            <div class="u-inner-row u-gap-8 u-inner-align-center">
                <span class="u-inner-row u-gap-8">
                    ${
            discounted != null
                ? `<strong>€${discounted}</strong><s>€${subtotal}</s>`
                : `<strong>€${subtotal}</strong>`
        }
                </span>
                ${discountPercent ? `<div class="block__preconfigurator-quantity-item-korting">${discountPercent}%</div>` : ""}
            </div>
        `;


        // Append
        $('.block__preconfigurator-quantity-custom-price').append(html);
    });


    // === Material Selection Handler ===
    $(document).on('change', 'input[name="material"]', function () {
        const selectedMaterialId = $(this).val();
        const selectedMaterial = StickerData.materials.data.find(m => m.uuid === selectedMaterialId);

        $('#width_custom_size').val('');
        $('#height_custom_size').val('');

        selectedOptions.selectedMaterialPercentage = selectedMaterial?.additionalCostPercentage || 0;
        updateAndRender();

        const allowedFinishes = selectedMaterial ? selectedMaterial.allowedFinishes : [];
        const $finishSelect = $('select[name="afwerking"]');
        $finishSelect.empty();

        $.each(StickerData.finishes.data, function (i, finish) {
            if (!allowedFinishes.includes(finish.uuid)) return;
            $finishSelect.append(`<option value="${finish.uuid}">${finish.label}</option>`);
        });

        // --- limits from material ---
        const minW = $(this).data('minwidth') ?? 3;
        const maxW = $(this).data('maxwidth') ?? 750;
        const minH = $(this).data('minheight') ?? 3;
        const maxH = $(this).data('maxheight') ?? 148;

        // Always keep inputs’ constraints in sync
        $('#width_custom_size').attr({min: minW, max: maxW});
        $('#height_custom_size').attr({min: minH, max: maxH});

        // --- filter preset sizes (hide/remove invalid) ---
        // choose .hide() to allow re-show on other materials, or .remove() to permanently remove
        $('[data-action="setup_size"]').each(function () {
            const sizeStr = $(this).data('value'); // e.g. "8 x 10 cm"
            const match = sizeStr.match(/([\d.,]+)\s*x\s*([\d.,]+)/i);
            if (!match) return;

            const w = parseFloat(String(match[1]).replace(',', '.'));
            const h = parseFloat(String(match[2]).replace(',', '.'));

            const valid = (w >= minW && w <= maxW && h >= minH && h <= maxH);
            if (!valid) {
                $(this).hide();          // or: $(this).remove();
            } else {
                $(this).show();
            }
        });

        // --- if currently selected size is invalid, snap to minW x minH ---
        const currentSizeStr = $('#size').val(); // e.g. "10 x 13 cm"
        const parsed = currentSizeStr && currentSizeStr.match(/([\d.,]+)\s*x\s*([\d.,]+)/i);
        let curW = parsed ? parseFloat(String(parsed[1]).replace(',', '.')) : NaN;
        let curH = parsed ? parseFloat(String(parsed[2]).replace(',', '.')) : NaN;

        const currentValid = !isNaN(curW) && !isNaN(curH) &&
            curW >= minW && curW <= maxW &&
            curH >= minH && curH <= maxH;

        if (!currentValid) {
            // fill the inputs with min values
            $('#width_custom_size').val(minW);
            $('#height_custom_size').val(minH);

            // sync the #size field so pricing/logic stays consistent
            const snapped = `${minW} x ${minH} cm`;
            $('#size').val(snapped).trigger('change');
        } else {
            // also clamp current inputs if they exist and are out of bounds
            const wInput = parseFloat($('#width_custom_size').val());
            const hInput = parseFloat($('#height_custom_size').val());

            if (isNaN(wInput) || wInput < minW || wInput > maxW) {
                $('#width_custom_size').val(Math.min(Math.max(curW, minW), maxW));
            }
            if (isNaN(hInput) || hInput < minH || hInput > maxH) {
                $('#height_custom_size').val(Math.min(Math.max(curH, minH), maxH));
            }
        }
    });


    $('input[name="quantity[]"]:checked').trigger('change');

    $(document).on('change', 'input[name="quantity[]"]', function () {

        $('.block__custom_block_js').show();
        $('.block__preconfigurator-quantity-custom').hide();

        let val = $(this).val();

        if (val == 'custom') {
            $('.block__custom_block_js').hide();
            $('.block__preconfigurator-quantity-custom').show();
        }

    });


    $(document).on('change', '#size', function () { // this is a input text?
        updateAndRender();
    });

    // === Finish Selection Handler ===
    $(document).on('change', 'select[name="afwerking"]', function () {
        const selectedFinishId = $(this).val();
        const selectedFinish = StickerData.finishes.data.find(f => f.uuid === selectedFinishId);

        selectedOptions.selectedFinishesPercentage = selectedFinish?.additionalCostPercentage || 0;
        updateAndRender();
    });

    // === Live size update if input changes ===
    $(document).on('input', '#size', function () {
        updateAndRender();
    });

    // === Initial calculation on page load ===
    updateAndRender();

    function getFormDataAsObject() {
        const data = {};
        const formArray = $('.block__preconfigurator-tool').serializeArray();

        formArray.forEach(({name, value}) => {
            if (data[name]) {
                // Handle multiple values (like shape[])
                if (!Array.isArray(data[name])) {
                    data[name] = [data[name]];
                }
                data[name].push(value);
            } else {
                data[name] = value;
            }
        });

        return data;
    }

    $(document).on('click', '[data-action="url-button"]', function (e) {
        e.preventDefault();

        const formData = getFormDataAsObject();

        // Parse width and height from "10 x 10 cm"
        const [width, height] = formData.size.split(' x ').map(v => v.replace(' cm', '').trim());

        // Translate shape
        const shapeMap = {
            'rond': 'round',
            'vierkant': 'square',
            'afgeronde_hoeken': 'rounded'
        };
        const productShape = shapeMap[formData['shape[]']] || formData['shape[]'];

        let quantity = formData['quantity[]'];

        if (quantity == 'custom') {
            quantity = $('input[name="custom_quantity"]').val();
        }

        // Build final parameters
        const queryParams = {
            productType: formData.type,
            productMaterial: formData.material,
            productFinish: formData.afwerking,
            productQuantity: quantity,
            productWidth: width,
            productHeight: height,
            productShape: productShape
        };

        // Build query string
        const queryString = Object.entries(queryParams)
            .map(([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
            .join('&');

        const url = `https://configurator.fixjesticker.nl/?${queryString}&tab=true`;

        // Open in new tab
        window.open(url, '_blank');

    });

}
